function getSystemTimezone():string{
    const systemOptions = new Intl.DateTimeFormat().resolvedOptions();
    return systemOptions.timeZone;
}

export {getSystemTimezone}